import { render, staticRenderFns } from "./quesTionList.vue?vue&type=template&id=1add2de4&scoped=true"
import script from "./quesTionList.vue?vue&type=script&lang=js"
export * from "./quesTionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add2de4",
  null
  
)

export default component.exports